import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './styles.css';

const Accolades = ({ isDarkMode }) => {
    // Throw an error if isDarkMode prop isn't provided
    if (isDarkMode === undefined) {
        throw new Error('isDarkMode prop is required for Accolades component');
    }

    const [accoladesData, setAccoladesData] = useState([]);

    useEffect(() => {
        fetch('/data/accolades.json')
            .then(response => response.json())
            .then(data => {
                // Keep only top 2 items per category
                const processedData = data.map(section => ({
                    ...section,
                    items: section.items.slice(0, 2)
                }));
                setAccoladesData(processedData);
            })
            .catch(error => console.error('Error fetching accolades data:', error));
    }, []);

    const scrollToBlog = () => {
        const blogSection = document.getElementById('blog');
        if (blogSection) {
            blogSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="mainArea transition-effect" id="accolades-section">
            <div className="accolades transition-effect">
                <div className="leftArea">
                    <img
                        src="/images/siteElements/topImg.jpeg"
                        alt="Accolades Top"
                        className="topImg"
                    />

                    <div className="contentArea">
                        <div className="leftContent">
                            <div className="sectionTitle">
                                Accolades
                            </div>

                            <img
                                src="/images/siteElements/scroll-down-short.png"
                                alt="Scroll Down Indicator"
                                className="accScrollDown"
                                onClick={scrollToBlog}
                            />
                        </div>
                        <div className="rightContent">
                            {accoladesData.map((section, index) => (
                                <div key={index} className="accoladesCard">
                                    <h3 className="accoladesTitle">{section.title}</h3>
                                    <ul className="accoladesList">
                                        {section.items.map((item, itemIndex) => (
                                            <li key={itemIndex} className="accoladeItem">
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}

                            <div className="accViewMoreContainer">
                                <Link to="/accolades" className="accViewMoreLink">
                                    View More <i className="fa-solid fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rightArea">
                    <img
                        src="/images/siteElements/topImg.jpeg"
                        alt="Accolades Right"
                        className="rightImg"
                    />
                </div>
            </div>
        </div>
    );
};

export default Accolades;